import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  container: {
    
    // display: "flex",
    // height: "100vh",
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    overflow: "hidden",
    background: "#fff",
    // zIndex: 1,
    height: "100vh",
    // width: "100%",
    // flex: 1,
    // flexDirection: "column",
    // backgroundSize: "cover",
    backgroundSize: "cover",
    backgroundPosition: "right",
    backgroundRepeat: "no-repeat",
    // [theme.breakpoints.down("sm")]: {
    //   flex: 0,
    // },
    // fontFamily: 'Ubuntu'
  },
  loginContainer: {
    // height: "100vh",
    // width: "100vw",
    // marginLeft: "6%",
    // justifyContent: "center",
    display: "flex",
    fontFamily: "Ubuntu",
    backgroundColor: "red",
  },
  formContainer: {
    maxWidth: 380,
    backgroundColor: "#f0f0f0",
    // padding: "25px 0px",
    // maxHeight: "375px",
    // position: "relative",
    // margin:'15% 2% 5% 20%',
    position: 'relative',
    left: '5%',
    // margin: 'auto 7% auto 17%',
    // top: "45%",
    borderRadius: "10px",
    boxShadow: "-60px 0px 100px -90px #000000, 60px 0px 100px -90px #000000",
    // transform: "translate(0, -50%)",
    [theme.breakpoints.down("sm")]: {
      minWidth: "unset",
      // width: "80%",
      margin :'20%'
    },
  },
  formLogo:{
    display:'flex',
    flexDirection: "column",
    alignItems:"center",
    backgroundColor: 'white',
    padding: '7%',
    borderRadius: '10px 10px 0 0'

  }
  ,
  loginImage: {
    height: "100vh",
    width: "100%",
    flex: 1,
    flexDirection: "column",
    // backgroundSize: "cover",
    backgroundSize: "cover",
    backgroundPosition: "right",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("sm")]: {
      flex: 0,
    },
  },
  loginTitle: {
    fontSize: 16,
    fontWeight: 300,
    
    fontFamily: "Ubuntu",
    // textTransform:'uppercase',
    textAlign: "center",
    color: "white",
    padding: "10px",
  },
  loginSubtitle: {
    fontSize: 14,
    fontFamily: "Ubuntu",
  },
  containerLabelPassword: {
    marginTop: 8,
    display: "flex",
    width: "100%",
    alignItems: "flex-end",
    fontFamily: "Ubuntu",
  },
  label: {
    fontSize: 14,
    marginTop: 14,
    marginLeft: 15,
    fontFamily: "Ubuntu",
    color: "#707070",
    // textTransform: "uppercase",
  },
  
  fieldIcon:{
     
    width: 16, marginLeft: 5,
    
  },
  input: {
    backgroundColor: "white",
    // border: "1px solid #ccd2d6",
    fontFamily: "Ubuntu",
    borderRadius: 20,
    width: "100%",
    "& ::placeholder": {
      color: "#848484",
      fontFamily: "Ubuntu",
    },
    
    "& input": {
      padding: "8px 12px",
      color: theme.palette.primary.main,
      fontFamily: "Ubuntu",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 20,
    },
  },
  visibility: {
    color: "#848484",
  },
  buttonSign: {
    marginTop: 10,
    width: "100%",
    color: "#fff",
    borderRadius: "2em",
    fontFamily: "Ubuntu",
    textTransform: "capitalize",
    
  },
  accountBtn:{
    "& :hover": {
      backgroundColor: theme.palette.primary.main,
     color:'white'
    },
  },
  passwordIcon:{
    "& :hover": {
      cursor:"pointer"
    }
  },
  copyright: {
    paddingTop: "5px",
    color: "white",
    fontSize: "0.9em",
    fontWeight: 700,
    fontFamily: "Ubuntu",
    // textAlign: 'right',
    // marginRight:'10px',
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  footer: {
    paddingTop: "5px",
    fontSize: "0.8em",
    fontFamily: "Ubuntu",
  },
}));
